import {Modal} from 'antd';
import React, {useState} from 'react';
import createReactClass from "create-react-class";


const MembershipContract = ({isVisible}) => {
    const [isModalVisible, setIsModalVisible] = useState(!isVisible);

    const handleOk = () => {
        setIsModalVisible(!isVisible);
    };

    const handleCancel = () => {
        setIsModalVisible(!isVisible);
    };

    /*const React = require('react');
    const createReactClass = require('create-react-class');
    module.exports = createReactClass({
        render: function () {
            return (
                    <h1>Liste</h1>
            )
        }
    });*/

    return (
        <>
            <Modal
                onOk={handleOk} onCancel={handleCancel}
                visible={isVisible}
            >



            </Modal>
        </>
    );
};

export default MembershipContract;